import React, { Fragment } from "react";
import { graphql } from "gatsby";
import Seo from "gatsby-plugin-wpgraphql-seo";
import {
  Layout,
  Banner,
  ImageContent,
  DiagnosisTests,
  ThreeBlogs,
  FullWidthContent,
  SliderImageContent,
  Tabs,
} from "../components";
import TableContent from "../components/Services/TableContent/TableContent";
import BlogPosts from "../components/Services/ThreeBlogs/BlogPosts";
import BookAnAppointmentBar from "../components/BookAnAppointmentBar.js";

const SingleService = ({
  data: {
    wpService,
    wpService: {
      pageMeta,
      pageMeta: { pageBanner, footer },
      servicesMeta: { contents },
    },
  },
}) => {
  return (
    <>
      <Seo post={wpService} />
      <Layout
        footerProps={{
          showBookAppointment: footer?.showBookAppointment,
        }}
      >
        <Banner banner={pageBanner} />
        {contents?.map((content, index) => {
          console.log("DEBUG__content", {
            contents,
            content,
          });
          return (
            <section
              className={`overflow-hidden py-12 ${
                content.fieldGroupName ===
                "Service_Servicesmeta_Contents_BookAnAppointmentSection"
                  ? "bg-primary"
                  : "bg-white"
              }`}
              key={index}
            >
              <div className="container mx-auto">
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_ImageContent" && (
                  <ImageContent data={content} />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_DiagnosisAndTest" && (
                  <DiagnosisTests data={content} />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_BookAnAppointmentSection" && (
                  <BookAnAppointmentBar
                    {...content}
                    buttonLink={content?.link}
                    className="py-0"
                  />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_Blog" && (
                  <ThreeBlogs data={content} />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_BlogPosts" && (
                  <BlogPosts posts={content} className="py-0" />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_FullWidthContent" && (
                  <FullWidthContent data={content} />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_SliderImageContent" && (
                  <SliderImageContent data={content} />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_Tabs" && (
                  <Tabs data={content} />
                )}
                {content.fieldGroupName ===
                  "Service_Servicesmeta_Contents_TableContent" && (
                  <TableContent data={content} />
                )}
              </div>
            </section>
          );
        })}
      </Layout>
    </>
  );
};

export default SingleService;

export const query = graphql`
  query ServiceQuery($id: Int) {
    wpService(databaseId: { eq: $id }) {
      pageMeta {
        pageBanner {
          desktopImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          mobileImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          captionTitle
          captionContent
          buttonLink
          buttonLabel
          showWhiteLogo
          whiteColor
          position
        }
        footer {
          showBookAppointment
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
      servicesMeta {
        contents {
          ... on WpService_Servicesmeta_Contents_ImageContent {
            fieldGroupName
            content
            buttons {
              blueButton
              buttonData {
                target
                title
                url
              }
            }
            title
            imagePosition
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
          }
          ... on WpService_Servicesmeta_Contents_DiagnosisAndTest {
            fieldGroupName
            title
            type
            slider {
              title
              content
              button {
                target
                title
                url
              }
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                  }
                }
              }
            }
          }
          ... on WpService_Servicesmeta_Contents_Blog {
            fieldGroupName
            chooseBlogs {
              ... on WpPost {
                uri
                title
                excerpt
              }
            }
          }
          ... on WpService_Servicesmeta_Contents_BlogPosts {
            fieldGroupName
            title
            blogs {
              ... on WpPost {
                id
                title
                excerpt
                slug
                date
                uri
                author {
                  node {
                    name
                  }
                }
                featuredImage {
                  node {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                      }
                    }
                  }
                }
              }
            }
            button {
              url
              title
            }
          }
          ... on WpService_Servicesmeta_Contents_BookAnAppointmentSection {
            fieldGroupName
            title
            subTitle
            description
            buttonText
            link
          }
          ... on WpService_Servicesmeta_Contents_FullWidthContent {
            fieldGroupName
            content
            subTitle
            textAlignment
            title
            button {
              target
              title
              url
            }
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
          }
          ... on WpService_Servicesmeta_Contents_Tabs {
            fieldGroupName
            tabContent {
              title
              contentType
              commonContent
              imageContent {
                content
                titlePosition
                titleColor
                title
                imagePosition
                image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(formats: WEBP, layout: FULL_WIDTH)
                    }
                  }
                }
                showBannerWithText
                bannerWithText {
                  image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(formats: WEBP, layout: FULL_WIDTH)
                      }
                    }
                  }
                  title
                  content
                }
                showBelowImageContent
                belowImageContent
              }
              faqs {
                title
                fieldGroupName
                content
              }
              column1 {
                content
                fieldGroupName
                title
              }
              column2 {
                title
                fieldGroupName
                content
              }
              listBox {
                title
                lists {
                  heading
                  content
                }
              }
            }
          }
          ... on WpService_Servicesmeta_Contents_SliderImageContent {
            fieldGroupName
            type
            sectionTitle
            slider {
              title
              buttons {
                blueButton
                buttonData {
                  target
                  title
                  url
                }
              }
              content
              fieldGroupName
              imagePosition
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                  }
                }
              }
            }
          }
          ... on WpService_Servicesmeta_Contents_TableContent {
            fieldGroupName
            title
            table {
              personsWithoutDiabetes
              personsWithDiabetes
            }
          }
        }
      }
    }
  }
`;
